import { useTranslation } from 'react-i18next';

import { useAuthorize } from '~features/authentication';
import { UserInvitationsDataGrid } from '~features/users';
import UserInvitationsOverviewContainer from '~features/users/containers/userInvitationsOverviewContainer';

import Page from '../page';

const UserInvitationsPage = () => {
	const { t } = useTranslation();
	const { isSuperAdmin } = useAuthorize();

	return (
		<Page title={t('nfcTags')}>
			<UserInvitationsOverviewContainer />
		</Page>
	);
};

export default UserInvitationsPage;
